<template>
<v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-card class="form-container" flat style="margin-top:-10px">
        <v-layout row wrap>
            <v-flex xs12 sm12 md8>
                <v-text-field v-model="purchaseCode" label="Enter a Purchase Order Id"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-btn :loading="seatchBtn" color="#e53935" dark depressed block large @click="searchData()">Seach Data</v-btn>
            </v-flex>
        </v-layout>
    </v-card>
    <v-card class="form-container" flat style="margin-top:-50px;border:1px solid" v-if="show==true">
      <v-form ref="form" v-model="valid" lazy-validation v-if="itemAdded.length>0">
        <v-container class="purchase-container" style="background-color:white">
          <v-layout row wrap>
            <v-flex xs12 sm12 md4>
              <v-text-field readonly v-model="form.vendorName" label="Vendor Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-text-field readonly v-model="form.gstNumber" label="GST number"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <v-text-field
                  append-icon="event"
                  v-model="form.purchaseDate"
                  label="Purchase Date"
                  readonly
                ></v-text-field>
            </v-flex>
            <!-- DUE DATE -->
            <v-flex xs12 sm12 md6>
              <v-dialog
                ref="dialog"
                v-model="grnDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="form.date"
                  label="GRN date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="form.date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="grnDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <!-- SHIP DATE -->
            <v-flex xs12 sm12 md6>
              <v-text-field
                  v-model="form.challanNumber"
                  label="Challan Number"
                   :rules="emptyRule" required
                ></v-text-field>
            </v-flex>

            <v-flex xs12>
                <v-data-table :headers="headers" :items="itemAdded" hide-actions>
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.item }}</td>
                  <td class="text-xs-left">{{ props.item.qty }}</td>
                  <td class="text-xs-left">
                      <input type="number" style="height:20px;width:100px;background-color:#eceff1" v-model="props.item.transferQty" />
                  </td>
                  <td class="text-xs-left">
                    <v-text-field v-model="props.item.batchNumber" :rules="emptyRule" required></v-text-field>
                  </td>
                  <td class="text-xs-left">
                      <input placeholder="yyyy-mm-dd" style="height:20px;width:100px;background-color:#eceff1" v-model="props.item.mfgDate" />
                  </td>
                  <td class="text-xs-left">
                      <input placeholder="yyyy-mm-dd" style="height:20px;width:100px;background-color:#eceff1" v-model="props.item.expDate" />
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <h3 v-if="itemAdded.length==0" style="text-align:center;color:red">This purchase order has been fully transferred</h3>
    </v-card>
</v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      dialog: false,
      seatchBtn: false,
      purchaseCode: null,
      show: false,
      snack: false,
      btnSave: false,
      snackColor: "",
      snackText: "",
      qtyRule: v => v.length > 0 || "Qty should be one at least!",
      grnDateModel: null,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "GRN",
          disabled: false,
          to: "/grn"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],

      itemAdded: [],
      itemAdded1: [],

      headers: [
        { text: "Item Name", value: "item" },
        { text: "Qty", value: "qty" },
        { text: "Transfer Qty", value: "transferQty" },
        { text: "Batch Number", value: "batchNumber" },
        { text: "MFG. Date", value: "mfgDate" },
        { text: "Exp. Date", value: "expDate" }
      ],
      valid: false,
      form: {
        purchaseDate: null,
        vendorName: null,
        gstNumber: null,
        date: new Date().toISOString().substr(0, 10),
        challanNumber: null
      },

      inputRules: [v => !!v || "This is empty !!"]
    };
  },

  mounted() {
    this.$Progress.start();
    
  },

  methods: {
    qtyClick(item) {
      console.log('OK');
      if(item.qty < item.transferQty) {
        item.transferQty = item.qty;
        this.$toaster.error(`Transfer Qty should be less than equal to Purchase Qty`);
      }
    },
      searchData() {
          if (this.purchaseCode != null) {
        this.seatchBtn = true;
        this.axios
          .post(
            config.API + `SearchPurchaseOrder`,
            {
              purchaseCode: this.purchaseCode
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.form = res.data;
            this.itemAdded = res.data.purchaseOrderDetails;
            this.show = true;
            this.seatchBtn = false;
          })
          .catch(err => {
            this.$toaster.error('Please enter a purchase order Id');
            this.seatchBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
      },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let lth = this.itemAdded.length;
      this.itemAdded1 = [];
      for(let i = 0; i < lth; i++) {
        if(JSON.parse(this.itemAdded[i].qty) < JSON.parse(this.itemAdded[i].transferQty)) {
          this.itemAdded1.push({
          productId: JSON.parse(this.itemAdded[i].productId),
          cgst: JSON.parse(this.itemAdded[i].cgst),
          cgstRate: JSON.parse(this.itemAdded[i].cgstRate),
          sgst: JSON.parse(this.itemAdded[i].sgst),
          sgstRate: JSON.parse(this.itemAdded[i].sgstRate),
          igst: JSON.parse(this.itemAdded[i].igst),
          igstRate: JSON.parse(this.itemAdded[i].igstRate),
          hsnRate: JSON.parse(this.itemAdded[i].hsnRate),
          purchaseRate: JSON.parse(this.itemAdded[i].purchaseRate),
          qty: JSON.parse(this.itemAdded[i].qty),
          transferQty: JSON.parse(this.itemAdded[i].qty),
          taxableAmount: JSON.parse(this.itemAdded[i].taxableAmount),
          batchNumber: this.itemAdded[i].batchNumber,
          mfgDate: this.itemAdded[i].mfgDate,
          expDate: this.itemAdded[i].expDate,
        })
        }
        else {
          this.itemAdded1.push({
          productId: JSON.parse(this.itemAdded[i].productId),
          cgst: JSON.parse(this.itemAdded[i].cgst),
          cgstRate: JSON.parse(this.itemAdded[i].cgstRate),
          sgst: JSON.parse(this.itemAdded[i].sgst),
          sgstRate: JSON.parse(this.itemAdded[i].sgstRate),
          igst: JSON.parse(this.itemAdded[i].igst),
          igstRate: JSON.parse(this.itemAdded[i].igstRate),
          hsnRate: JSON.parse(this.itemAdded[i].hsnRate),
          purchaseRate: JSON.parse(this.itemAdded[i].purchaseRate),
          qty: JSON.parse(this.itemAdded[i].qty),
          transferQty: JSON.parse(this.itemAdded[i].transferQty),
          taxableAmount: JSON.parse(this.itemAdded[i].taxableAmount),
          batchNumber: this.itemAdded[i].batchNumber,
          mfgDate: this.itemAdded[i].mfgDate,
          expDate: this.itemAdded[i].expDate,
        })
        }
      }
      this.axios
        .post(
          config.API + "Grns",
          {
            date: this.form.date,
            purchaseId: this.form.id,
            challanNumber: this.form.challanNumber,

            grnLists: this.itemAdded1
          },
          {
            headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
          }
        )
        .then(res => {
          this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.btnSave = false;
        });
      }
      else {
        this.$toaster.error(`Required field(s) are empty`);
      }
    }
  }
};
</script>